import { useQuery } from '@tanstack/react-query'
import { authApi } from '../services/auth.service'
import { useApiAuth } from '../state/apiAuthStore'
import { qk } from '@/lib/api/queryKeys'

export function useMe() {
  const isAuthed = useApiAuth((s) => s.isAuthed)
  const setUser = useApiAuth((s) => s.setUser)

  return useQuery({
    queryKey: qk.auth.me,
    queryFn: async () => {
      const u = await authApi.me()
      setUser(u)
      return u
    },
    enabled: isAuthed,
    staleTime: 5 * 60_000,
  })
}
